import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';

interface LoadingCircleProps {
  size?: number;
  thickness?: number;
  fullScreen?: boolean;
}

const LoadingCircle: React.FC<LoadingCircleProps> = ({ size = 40, thickness = 4, fullScreen = false }) => {
  const containerStyle = fullScreen ? {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: '#0A0F15',
    zIndex: 9999,
  } : {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <Box sx={containerStyle}>
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <CircularProgress
          size={size}
          thickness={thickness}
          sx={{
            color: 'transparent',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
              stroke: 'url(#gradient)',
            },
          }}
        />
        <svg width="0" height="0">
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#7B2CBF" />
              <stop offset="100%" stopColor="#E31B88" />
            </linearGradient>
          </defs>
        </svg>
      </motion.div>
    </Box>
  );
};

export default LoadingCircle; 